<template>
  <div class="kye-date-picker2_time-step-select" ref="timeStepSelect">
    <div class="time-step-select_input">
      <el-input
        class="time-setp-select_inputdom"
        ref="input"
        :value="visibleTime"
        @input="(val) => (userInputTime = val)"
        @change="handleKeydown"
      />
    </div>
    <div class="kye-date-picker2_time-step-content">
      <div class="wrap">
        <div
          v-for="item in items"
          class="time-step-select-item"
          :class="{
            selected: visibleTime === item.value && !item.disabled,
            disabled: item.disabled,
          }"
          :disabled="item.disabled"
          :key="item.value"
          @click="handleClick(item)"
        >
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import moment from 'moment'
import {
  parseTimeDate,
  modifyTime,
  formatDate,
  extractTimeFormat,
} from '../utils'

const parseTime = function(time) {
  const values = (time || '').split(':')
  if (values.length >= 2) {
    const hours = parseInt(values[0], 10)
    const minutes = parseInt(values[1], 10)

    return {
      hours,
      minutes,
    }
  }
  /* istanbul ignore next */
  return null
}

const compareTime = function(time1, time2) {
  const value1 = parseTime(time1)
  const value2 = parseTime(time2)

  const minutes1 = value1.minutes + value1.hours * 60
  const minutes2 = value2.minutes + value2.hours * 60

  if (minutes1 === minutes2) {
    return 0
  }

  return minutes1 > minutes2 ? 1 : -1
}

const formatTime = function(time) {
  return (
    (time.hours < 10 ? '0' + time.hours : time.hours) +
    ':' +
    (time.minutes < 10 ? '0' + time.minutes : time.minutes)
  )
}

const nextTime = function(time, step) {
  const timeValue = parseTime(time)
  const stepValue = parseTime(step)

  const next = {
    hours: timeValue.hours,
    minutes: timeValue.minutes,
  }

  next.minutes += stepValue.minutes
  next.hours += stepValue.hours

  next.hours += Math.floor(next.minutes / 60)
  next.minutes = next.minutes % 60

  return formatTime(next)
}

export default {
  watch: {
    value(val) {
      if (!val) return
      // 修改内部值
      this.userInputTime = moment(val).format('HH:mm') || '00:00'
      // this.$nextTick(() => this.scrollToOption())
    },
  },
  mounted() {
    this.$emit('mounted')
  },
  methods: {
    handleClick(item) {
      if (!item.disabled) {
        const [h = 0, m = 0, s = 0] = item.value.split(':')
        const date = modifyTime(this.date, h, m, s)
        this.value = date
        this.userInputTime = item.value
        this.$emit('pick', date)
      }
    },

    scrollToOption(selector = '.selected') {
      const menu = this.$refs.timeStepSelect.querySelector('.wrap')
      if (!menu) {
        return
      }
      const index = Array.from(menu.childNodes).findIndex(v => v.classList.contains('selected'))
      const gapSize = parseInt(window.getComputedStyle(menu).gap) || 6 // flex的gap值
      const scrollTop = (menu.firstChild.offsetHeight * index) + ((index - 1) * gapSize)
      menu.scrollTop = scrollTop
    },

    handleKeydown() {
      const { date, timeValue } =
        parseTimeDate(this.visibleTime, this.format, this.date) || {}
      if (date) {
        // 是否是禁用的
        const disabled =
          compareTime(timeValue, this.minTime || '-1:-1') <= 0 ||
          compareTime(timeValue, this.maxTime || '100:100') >= 0
        this.userInputTime = timeValue
        if (disabled) {
          return
        }
        // 是否存在与列表中
        let index = this.items.map((item) => item.value).indexOf(timeValue)
        if (index === -1) {
          return
        }
        this.date = date
        this.$emit('pick', date)
      } else {
        this.userInputTime = ''
      }
      this.$nextTick(() => {
        this.scrollToOption()
      })
      return false
    },
  },
  props: {
    start: {
      type: String,
      default: '00:00',
    },
    end: {
      type: String,
      default: '23:59',
    },
    step: {
      type: String,
      default: '00:01',
    },
    maxTime: String,
    minTime: String,
    stepOptions: Array
  },

  data() {
    return {
      value: '',
      userInputTime: null,
      date: new Date(),
      format: 'HH:mm',
    }
  },

  computed: {
    timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format)
      } else {
        return 'HH:mm'
      }
    },
    visibleTime() {
      if (this.userInputTime !== null) {
        return this.userInputTime
      } else {
        return formatDate(this.value, this.timeFormat)
      }
    },
    items() {
      if (this.stepOptions && this.stepOptions.length) {
        return this.stepOptions
      }
      const start = this.start
      const end = this.end
      const step = this.step

      const result = []

      if (start && end && step) {
        let current = start
        while (compareTime(current, end) <= 0) {
          result.push({
            value: current,
            disabled:
              compareTime(current, this.minTime || '-1:-1') <= 0 ||
              compareTime(current, this.maxTime || '100:100') >= 0,
          })
          current = nextTime(current, step)
        }
      }

      return result
    },
  },
}
</script>

<style lang="scss">
.kye-date-picker2 {
  &_time-step-select {
    width: 96px;
    height: 315px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 16px 6px 12px;
    .time-step-select_input {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
      height: 28px;
      &dom {
        width: 120px;
      }
    }
  }
  &_time-step-content {
    width: 100%;
    flex: 1;
    overflow: hidden;
    .wrap {
      height: 100%;
      overflow: auto;
      padding-right: 4px;
      &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
      }
      /* 滚动条有滑块的轨道部分 */
      &::-webkit-scrollbar-track-piece {
        background-color: transparent;
        border-radius: 5px;
      }
      /* 滚动条滑块(竖向:vertical 横向:horizontal) */
      &::-webkit-scrollbar-thumb {
        cursor: pointer;
        // background-color:rgba(144, 147, 153, 0.3);
        background-color: #e9ddfc;
        border-radius: 5px;
      }
      /* 滚动条滑块hover */
      &::-webkit-scrollbar-thumb:hover {
        // background-color: rgba(144, 147, 153, 0.3);
        background-color: #e9ddfc;
      }
      /* 同时有垂直和水平滚动条时交汇的部分 */
      &::-webkit-scrollbar-corner {
        display: block; /* 修复交汇时出现的白块 */
      }
      display: flex;
      flex-direction: column;
      gap: 6px;
      .time-step-select-item {
        padding: 4px 10px;
        font-size: 12px;
        color: #606266;
        font-weight: bold;
        line-height: 20px;
      }
      .time-step-select-item:not(.disabled, .selected) {
        cursor: pointer;
        &:hover {
          background-color: #f4f0ff;
          border-radius: 4px;
        }
      }
      .time-step-select-item.disabled {
        cursor: not-allowed;
        // background-color: ;
        color: #e4e7ed;
      }
      .time-step-select-item.selected {
        color: #fff;
        background-color: #7653d6;
        border-radius: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/basic/time-step-select.vue